import { normalizeCompanyLinkSiteId } from './helpers';

export const getShouldHandleConnectedArtists = ({
  hasArtistConnections,
  initialSiteId,
  submittedSiteId,
}: {
  hasArtistConnections: boolean;
  initialSiteId: string | null | undefined;
  submittedSiteId: string | null | undefined;
}): boolean => {
  if (!hasArtistConnections) {
    return false;
  }
  return (
    normalizeCompanyLinkSiteId(initialSiteId) !==
    normalizeCompanyLinkSiteId(submittedSiteId)
  );
};
